import React from 'react';
import MealRow from './MealRow';

const MealRows = ({ t, mealsForDay, openMealModal,closeMealModal }) => {
    const mealRows = [];
    mealsForDay.forEach((meal, key) => {
        mealRows.push(
            <MealRow
                t={t}
                key={key}
                meal={meal}
                mealOfDay={key}
                closeMealModal={closeMealModal}
                openMealModal={openMealModal}
            />
        );
    });
    return mealRows;
}

export default MealRows;
